/**
 * 화면 오른쪽 아래에 떠 있는 버튼 두 개(레이 AI 도우미 · 운영팀 대화방)가 겹치지 않게 하는 한 곳 (2026-10-23)
 *
 *   · 레이 런처 자리: 모바일 오른쪽 16px · 아래 76px(하단 바 위) · PC 오른쪽 20px · 아래 20px · 높이 44px
 *     (src/components/lay/LayWidget.jsx 의 런처 위치와 같아야 한다)
 *   · 운영팀 대화 버튼은 그 바로 위 10px 에 둔다 — LAY 자리를 옮기면 OPS_CHAT 자리도 같이 옮긴다.
 *   · 레이 창이 열려 있는 동안은 대화 버튼을 숨기고(PC 에서 열려 있던 운영팀 작은 창은 내린다),
 *     모바일에서 운영팀 대화 시트가 열려 있는 동안은 레이 런처를 숨긴다. PC 는 시안대로 레이 버튼 위에 작은 창을 띄운다.
 *     둘은 window 이벤트로만 서로를 안다.
 * 기획 docs/ops/ops-chat-room-plan.md §3-1
 */
export const LAY_LAUNCHER = Object.freeze({ right: { base: 16, md: 20 }, bottom: { base: 76, md: 20 }, height: 44 });
const GAP = 10;
export const OPS_CHAT_BUTTON_SIZE = 52;
export const OPS_CHAT_BUTTON = Object.freeze({
  right: { base: LAY_LAUNCHER.right.base - (OPS_CHAT_BUTTON_SIZE - LAY_LAUNCHER.height) / 2, md: LAY_LAUNCHER.right.md },
  bottom: { base: LAY_LAUNCHER.bottom.base + LAY_LAUNCHER.height + GAP, md: LAY_LAUNCHER.bottom.md + LAY_LAUNCHER.height + GAP },
});

const LAY_EVENT = "laeebly:lay-open";
const OPS_EVENT = "laeebly:ops-chat-open";
let layCovering = false;
let opsOpen = false;

/** 레이 위젯이 부른다 — covering: 레이 창이 오른쪽 아래를 덮는가(모바일 전체 화면 · PC 옆 패널 · 떠 있는 창) */
export function announceLayOpen(covering) {
  layCovering = Boolean(covering);
  if (typeof window !== "undefined") window.dispatchEvent(new CustomEvent(LAY_EVENT, { detail: layCovering }));
}
export function onLayOpenChange(cb) {
  cb(layCovering);
  const h = (e) => cb(Boolean(e.detail));
  window.addEventListener(LAY_EVENT, h);
  return () => window.removeEventListener(LAY_EVENT, h);
}

/** 운영팀 대화창이 부른다 */
export function announceOpsChatOpen(open) {
  opsOpen = Boolean(open);
  if (typeof window !== "undefined") window.dispatchEvent(new CustomEvent(OPS_EVENT, { detail: opsOpen }));
}
export function onOpsChatOpenChange(cb) {
  cb(opsOpen);
  const h = (e) => cb(Boolean(e.detail));
  window.addEventListener(OPS_EVENT, h);
  return () => window.removeEventListener(OPS_EVENT, h);
}
